import { render, staticRenderFns } from "./ModalAtualizarHistorico.vue?vue&type=template&id=00a03272&"
import script from "./ModalAtualizarHistorico.vue?vue&type=script&lang=js&"
export * from "./ModalAtualizarHistorico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports